import { NOT_APPLICABLE } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { SECURITY_FRACTIONAL_DENOMINATOR_VALUES } from '@dealstack/shared/lib/common/securities/securities.ts';
import { normalizeScreamingSnakeToUI } from '@dealstack/shared/lib/format/string.ts';
import { SecurityEquityBasis, SecurityIssuedIn } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from './mechanism/i18n/i18nHooks.types';

export const SECURITY_ISSUED_IN_OPTIONS = Object.values(SecurityIssuedIn).map((type) => {
	return {
		value: type,
		label: normalizeScreamingSnakeToUI(type),
	};
});
export const SECURITY_EQUITY_BASIS_OPTIONS = Object.values(SecurityEquityBasis).map((type) => {
	return {
		value: type,
		label: normalizeScreamingSnakeToUI(type),
	};
});

export const makeSecurityDenominatorLabel = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>,
	value?: number
): string => {
	if (!value || value === 1) {
		return NOT_APPLICABLE;
	}

	const decimalPlaces = Math.log10(value);
	return tCommonUI('decimal_places', {
		value: decimalPlaces,
	});
};

export const makeSecurityUnitDenominatorOptions = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>,
	minAllowedUnitDenominator?: number | null
) =>
	SECURITY_FRACTIONAL_DENOMINATOR_VALUES.map((value) => ({
		value,
		label: makeSecurityDenominatorLabel(tCommonUI, value),
		disabled: value < (minAllowedUnitDenominator || 1),
	}));
